import { Component } from '@angular/core';

@Component({
    selector: 'return-preview',
    templateUrl: './returnPreview.component.html',
    styleUrls: ['./returnPreview.component.scss'],
    standalone: false
})
export class ReturnPreviewComponent {
}
